import { InputTypes, ValidatorTypes } from '@cashier/cashier-model';

import { provideTermsAgreementToggler } from '../staticDataProviders';
import { SchemaCollector } from './model';

const CVV_TYPES = new Set([InputTypes.Cvv, InputTypes.CardCvc]);
const CVV_NAME = 'cvv';
const EXPIRATION_DATE_NAME = 'expirationDate';
const CARD_HOLDER_NAME = 'cardHolder';
const CARD_NUMBER_NAME = 'creditcardNumber';

export const CardDataCollector: SchemaCollector = {
  collect: (formSchema, field, context) => {
    const cardData = formSchema.cardData || {};

    if (!cardData.termsAgreementToggler) {
      const {
        paymentType,
        paymentMethod: { id, categories },
      } = context;

      const termsAgreementToggler = provideTermsAgreementToggler(paymentType, {
        id,
        categories,
      });

      if (termsAgreementToggler) {
        cardData.termsAgreementToggler = {
          ...termsAgreementToggler,
          validatorType: ValidatorTypes.COMMON,
        };
      }
    }

    if (
      !cardData.cvv &&
      (CVV_TYPES.has(field.type) || field.name === CVV_NAME)
    ) {
      cardData.cvv = { ...field, validatorType: ValidatorTypes.COMMON };
    }

    if (!cardData.cardHolder && CARD_HOLDER_NAME === field.name) {
      cardData.cardHolder = { ...field, validatorType: ValidatorTypes.COMMON };
    }

    if (!cardData.cardNumber && CARD_NUMBER_NAME === field.name) {
      cardData.cardNumber = { ...field, validatorType: ValidatorTypes.COMMON };
    }

    if (
      !cardData.expirationDate &&
      (EXPIRATION_DATE_NAME === field.name ||
        InputTypes.DateTime === field.type)
    ) {
      cardData.expirationDate = {
        ...field,
        validatorType: ValidatorTypes.COMMON,
      };
    }

    if (Object.keys(cardData).length > 0) {
      formSchema.cardData = cardData;
    }
  },
  shouldCollect: (field) => {
    return (
      CVV_TYPES.has(field.type) ||
      CVV_NAME === field.name ||
      CARD_HOLDER_NAME === field.name ||
      CARD_NUMBER_NAME === field.name ||
      EXPIRATION_DATE_NAME === field.name ||
      InputTypes.DateTime === field.type
    );
  },
};
